/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'
import { withFormik } from 'formik'
/** @todo No @types for yup so have to require over import to skip TSC */
const Yup = require('yup')

/**
 *     Import
 *     - Components
 */
import AddressLookup from '../../../../../containers/common/Address/Address'
import { Dropdown } from '../../../../common/Dropdown/Dropdown'
import { SearchSelect } from '../../../../common/SearchSelect/SearchSelect'
import { Button } from '../../../../common/Button/Button'

const addressTypeList = [
    { value: 'home', text: 'Home' },
    { value: 'office', text: 'Office' },
    { value: 'storage location', text: 'Storage' },
    { value: 'retail location', text: 'Retail' },
]

const addressTypeListOfCollectors = [
    { value: 'home', text: 'Office, Home or Other' },
    { value: 'museum', text: 'Museum' },
    { value: 'storage', text: 'Storage facility' },
]

class AddressNewForm extends React.Component<any, any> {
    state = {
        isUK: true,
        countryId: null,
        addressType: null,
        saveButtonText: 'Save and add security details',
    }

    componentDidMount(): void {
        if (this.props.isCollectors) {
            this.props.setFieldValue('addressType', addressTypeListOfCollectors[0].value)
            this.setState({ addressType: addressTypeListOfCollectors[0].value })
        }

        if (this.props.isMuseums || this.props.isDealersStock) {
            this.props.setFieldValue('addressType', addressTypeListOfCollectors[0].value)
            this.setState({ addressType: addressTypeListOfCollectors[0].value })
        }
    }

    /**
     * set fields on Formik state and
     * also set those fields as Touched to trigger the validation
     */
    addressChange = (field: any, value: any) => {
        this.props.setFieldTouched(field, true)
        this.props.setFieldValue(field, value)
        if (field === 'addressType') {
            if (value === 'home' ||
                value === 'office' ||
                value === 'storage location' ||
                value === 'retail location') {
                this.setState({
                    saveButtonText: 'Save and add security details',
                })
            } else {
                this.setState({
                    saveButtonText: 'Save',
                })
            }
        }
        if (this.props.isCollectors || this.props.isMuseums || this.props.isDealersStock) {
            if (field === 'addressType' && value !== this.state.addressType) {
                this.setState({ addressType: value })
                this.props.resetForm({
                    countryId: this.state.countryId,
                    addressType: value,
                })
            }
        }
    }

    /**
     * handle the click on Cancel button
     */
    handleCancel = () => this.props.handleCancel()

    handleCountrySelect = (name: string, value: number) => {
        const currentCountry = this.props.countries.find(country => country.id === value)
        this.setState({
            countryId: value,
            isUK: currentCountry.name.toUpperCase() === 'UK',
        })
        this.props.setFieldValue(name, value)
    }

    getAddressTypes = (isCollectors: boolean): any[] => {
        const { isMuseums, isDealersStock } = this.props
        if (!isCollectors && !isMuseums && !isDealersStock) {
            return addressTypeList
        }
        return addressTypeListOfCollectors
    }

    getInitialAddressType = (isCollectors: boolean): any[] => {
        const { isMuseums, isDealersStock } = this.props

        if (!isCollectors && !isMuseums && !isDealersStock) {
            return [addressTypeList[0].value, addressTypeList[0].text]
        }
        return [addressTypeListOfCollectors[0].value, addressTypeListOfCollectors[0].text]
    }

    getInitialCountry = (): any[] => {
        if (this.props.countries.length !== 0) {
            return [this.props.countries[0].id, this.props.countries[0].name]
        }
        return [null, '']
    }

    mapCountriesToDropdownList = (countries) => {
        return countries
            .map(country => ({
                value: country.id,
                text: country.name,
            }))
    }

    render() {
        const {
            isCollectors,
            countries,
        } = this.props
        const {
            isUK,
            addressType,
            countryId,
            saveButtonText,
        } = this.state

        const countryDropdownList = this.mapCountriesToDropdownList(countries)

        return (
            <div className="addressBlock__content">
                <form onSubmit={this.props.handleSubmit} autoComplete="off" >
                    <div className="wrap_padding">
                        <div className="quote__form__group form__w60">
                            <Dropdown
                                itemList={this.getAddressTypes(isCollectors)}
                                name="addressType"
                                setFieldValue={this.addressChange}
                                label="Address type"
                                selected={this.getInitialAddressType(isCollectors)}
                            />
                        </div>                  
                        <div className="quote__form__group form__w40">
                            <SearchSelect
                                itemList={countryDropdownList}
                                name="countryId"
                                setFieldValue={this.handleCountrySelect}
                                label="Country"
                                selected={this.getInitialCountry()}
                            />
                        </div>
                        <AddressLookup
                            setAddress={this.addressChange}
                            getLatLongTrigger={this.props.getLatLongTrigger}
                            isAddressLookupByTermShown={isUK}
                            addressType={addressType}
                            countryId={countryId}
                        />
                    </div>
                    <div className="addressBlock__actions">

                        <Button
                            half={true}
                            type="button"
                            onClick={this.handleCancel}
                        >
                            Cancel
                        </Button>
                        <Button
                            half={true}
                            type="submit"
                            disabled={!this.props.isValid}
                        >
                            {saveButtonText}
                        </Button>

                    </div>
                </form>
            </div>
        )
    }
}

/**
 *     Formik Validation Struture
 */
const AddressNew = withFormik<any, any>({

    mapPropsToValues: (props: any) => {
        return {
            addressType: '',
            addressLine1: '',
            addressLine2: '',
            city: '',
            lat: '',
            lng: '',
            countryId: '',
            museum: '',
            storageLocation: '',
            unit: '',
            floor: '',
            isCollectors: props.isCollectors,
            isMuseums: props.isMuseums,
            isDealersStock: props.isDealersStock,
        }
    },

    validateOnChange: true,
    validateOnBlur: true,

    validationSchema: (props: any) => {
        return Yup.lazy(values => {
            switch (values.addressType) {
                case 'museum':
                    return Yup.object().shape({
                        addressType: Yup.string().required('addressType is required'),
                        museum: Yup.string().required('museum is required'),
                        city: Yup.string().required('city is required'),
                        countryId: Yup.number().required('country is required'),
                    })
                case 'storage':
                    return Yup.object().shape({
                        addressType: Yup.string().required('addressType is required'),
                        storageLocation: Yup.string().required('storage location is required'),
                        unit: Yup.string(),
                        floor: Yup.string(),
                        city: Yup.string().required('city is required'),
                        countryId: Yup.number().required('country is required'),
                    })
                default:
                    return Yup.object().shape({
                        isCollectors: Yup.boolean(),
                        isMuseums: Yup.boolean(),
                        isDealersStock: Yup.boolean(),
                        addressType: Yup.string().required('addressType is required'),
                        addressLine1: Yup.string().required('addressLine1 is required'),
                        addressLine2: Yup.string(),
                        lat: Yup.string(),
                        lng: Yup.string(),
                        city: Yup.string().required('city is required'),
                        postcode: Yup.string().required('postcode is required'),
                        countryId: Yup.number().when(['isCollectors', 'isMuseums', 'isDealersStock'], {
                            is: (isCollectors, isMuseums, isDealersStock) => (isCollectors ||
                                isMuseums ||
                                isDealersStock),
                            then: Yup.number().required('country is required'),
                            otherwise: Yup.number(),
                        }),
                    })
            }
        })
    },

    handleSubmit: (values, { props, setSubmitting }) => {
        // Submit values to endpoint
        let address = { 'riskLocation': values }
        // props.createNewAddress(address)
        props.toggleContent(address)
    },

})(AddressNewForm)

export default AddressNew



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/pages/Quote/Step02/components/AddressNew.tsx